/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
  useMutation,
  MutationHookOptions,
  MutationTuple,
} from 'data-fetching-client';
import * as References from './ApprovalsRpc';
import * as Queries from './ApprovalsRpc.dfc.new';
import type { AdditionalContextArgs } from './ApprovalsRpc.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type MutationTupleOverride<Response, Request, DataOverride> = OverrideData<
  MutationTuple<Response, Request>,
  DataOverride
>;
type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseCreateApprovalMutationReturn<T extends boolean> = MutationTupleOverride<
  Record<'result', References.CreateApprovalResponseType>,
  References.CreateApprovalRequestType,
  T extends true
    ? Record<'createApproval', References.CreateApprovalResponseType>
    : References.CreateApprovalResponseType
>;

export function useCreateApprovalMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.CreateApprovalResponseType>,
    References.CreateApprovalRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseCreateApprovalMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.CREATE_APPROVAL_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            createApproval: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseCreateApprovalMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseCreateApprovalMutationReturn<T>;
}

type UseCreateBulkApprovalMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.CreateBulkApprovalResponseType>,
    References.CreateBulkApprovalRequestType,
    T extends true
      ? Record<'createBulkApproval', References.CreateBulkApprovalResponseType>
      : References.CreateBulkApprovalResponseType
  >;

export function useCreateBulkApprovalMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.CreateBulkApprovalResponseType>,
    References.CreateBulkApprovalRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseCreateBulkApprovalMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.CREATE_BULK_APPROVAL_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            createBulkApproval: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseCreateBulkApprovalMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseCreateBulkApprovalMutationReturn<T>;
}

type UseGetLatestApprovalQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetLatestApprovalResponseType>,
    References.GetLatestApprovalRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getLatestApproval', References.GetLatestApprovalResponseType>
        : References.GetLatestApprovalResponseType)
    | undefined;
};

export function useGetLatestApprovalQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetLatestApprovalResponseType>,
    References.GetLatestApprovalRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetLatestApprovalQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_LATEST_APPROVAL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getLatestApproval: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetLatestApprovalQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetLatestApprovalQueryReturn<T>;
}

type UseGetLatestApprovalLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetLatestApprovalResponseType>,
    References.GetLatestApprovalRequestType,
    T extends true
      ? Record<'getLatestApproval', References.GetLatestApprovalResponseType>
      : References.GetLatestApprovalResponseType
  >;

export function useGetLatestApprovalLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetLatestApprovalResponseType>,
    References.GetLatestApprovalRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetLatestApprovalLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_LATEST_APPROVAL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getLatestApproval: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetLatestApprovalLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetLatestApprovalLazyQueryReturn<T>;
}

type UseGetLatestApprovalSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetLatestApprovalResponseType>,
    References.GetLatestApprovalRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getLatestApproval', References.GetLatestApprovalResponseType>
    : References.GetLatestApprovalResponseType;
};

export function useGetLatestApprovalSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetLatestApprovalResponseType>,
    References.GetLatestApprovalRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetLatestApprovalSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_LATEST_APPROVAL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getLatestApproval: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetLatestApprovalSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetLatestApprovalSuspenseQueryReturn<T>;
}

type UseGetApprovalQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetApprovalResponseType>,
    References.GetApprovalRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getApproval', References.GetApprovalResponseType>
        : References.GetApprovalResponseType)
    | undefined;
};

export function useGetApprovalQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetApprovalResponseType>,
    References.GetApprovalRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetApprovalQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_APPROVAL_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getApproval: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return { data: legacyFormatData, ...rest } as UseGetApprovalQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetApprovalQueryReturn<T>;
}

type UseGetApprovalLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetApprovalResponseType>,
    References.GetApprovalRequestType,
    T extends true
      ? Record<'getApproval', References.GetApprovalResponseType>
      : References.GetApprovalResponseType
  >;

export function useGetApprovalLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetApprovalResponseType>,
    References.GetApprovalRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetApprovalLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_APPROVAL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getApproval: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetApprovalLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetApprovalLazyQueryReturn<T>;
}

type UseGetApprovalSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetApprovalResponseType>,
    References.GetApprovalRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getApproval', References.GetApprovalResponseType>
    : References.GetApprovalResponseType;
};

export function useGetApprovalSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetApprovalResponseType>,
    References.GetApprovalRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetApprovalSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_APPROVAL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getApproval: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetApprovalSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetApprovalSuspenseQueryReturn<T>;
}

type UseApproveApprovalMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.ApproveApprovalResponseType>,
    References.ApproveApprovalRequestType,
    T extends true
      ? Record<'approveApproval', References.ApproveApprovalResponseType>
      : References.ApproveApprovalResponseType
  >;

export function useApproveApprovalMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.ApproveApprovalResponseType>,
    References.ApproveApprovalRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseApproveApprovalMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.APPROVE_APPROVAL_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            approveApproval: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseApproveApprovalMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseApproveApprovalMutationReturn<T>;
}

type UseApproveApprovalStepMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.ApproveApprovalStepResponseType>,
    References.ApproveApprovalStepRequestType,
    T extends true
      ? Record<
          'approveApprovalStep',
          References.ApproveApprovalStepResponseType
        >
      : References.ApproveApprovalStepResponseType
  >;

export function useApproveApprovalStepMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.ApproveApprovalStepResponseType>,
    References.ApproveApprovalStepRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseApproveApprovalStepMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.APPROVE_APPROVAL_STEP_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            approveApprovalStep: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseApproveApprovalStepMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseApproveApprovalStepMutationReturn<T>;
}

type UseRejectApprovalMutationReturn<T extends boolean> = MutationTupleOverride<
  Record<'result', References.RejectApprovalResponseType>,
  References.RejectApprovalRequestType,
  T extends true
    ? Record<'rejectApproval', References.RejectApprovalResponseType>
    : References.RejectApprovalResponseType
>;

export function useRejectApprovalMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.RejectApprovalResponseType>,
    References.RejectApprovalRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseRejectApprovalMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.REJECT_APPROVAL_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            rejectApproval: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseRejectApprovalMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseRejectApprovalMutationReturn<T>;
}

type UseRejectApprovalStepMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.RejectApprovalStepResponseType>,
    References.RejectApprovalStepRequestType,
    T extends true
      ? Record<'rejectApprovalStep', References.RejectApprovalStepResponseType>
      : References.RejectApprovalStepResponseType
  >;

export function useRejectApprovalStepMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.RejectApprovalStepResponseType>,
    References.RejectApprovalStepRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseRejectApprovalStepMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.REJECT_APPROVAL_STEP_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            rejectApprovalStep: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseRejectApprovalStepMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseRejectApprovalStepMutationReturn<T>;
}

type UseRequestChangesOnApprovalMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.RequestChangesOnApprovalResponseType>,
    References.RequestChangesOnApprovalRequestType,
    T extends true
      ? Record<
          'requestChangesOnApproval',
          References.RequestChangesOnApprovalResponseType
        >
      : References.RequestChangesOnApprovalResponseType
  >;

export function useRequestChangesOnApprovalMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.RequestChangesOnApprovalResponseType>,
    References.RequestChangesOnApprovalRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseRequestChangesOnApprovalMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.REQUEST_CHANGES_ON_APPROVAL_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            requestChangesOnApproval: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseRequestChangesOnApprovalMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseRequestChangesOnApprovalMutationReturn<T>;
}

type UseRequestChangesOnApprovalStepMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.RequestChangesOnApprovalStepResponseType>,
    References.RequestChangesOnApprovalStepRequestType,
    T extends true
      ? Record<
          'requestChangesOnApprovalStep',
          References.RequestChangesOnApprovalStepResponseType
        >
      : References.RequestChangesOnApprovalStepResponseType
  >;

export function useRequestChangesOnApprovalStepMutation<
  T extends boolean = false,
>(
  options?: MutationHookOptions<
    Record<'result', References.RequestChangesOnApprovalStepResponseType>,
    References.RequestChangesOnApprovalStepRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseRequestChangesOnApprovalStepMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.REQUEST_CHANGES_ON_APPROVAL_STEP_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            requestChangesOnApprovalStep: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseRequestChangesOnApprovalStepMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseRequestChangesOnApprovalStepMutationReturn<T>;
}

type UseMarkChangesResolvedMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.MarkChangesResolvedResponseType>,
    References.MarkChangesResolvedRequestType,
    T extends true
      ? Record<
          'markChangesResolved',
          References.MarkChangesResolvedResponseType
        >
      : References.MarkChangesResolvedResponseType
  >;

export function useMarkChangesResolvedMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.MarkChangesResolvedResponseType>,
    References.MarkChangesResolvedRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseMarkChangesResolvedMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.MARK_CHANGES_RESOLVED_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            markChangesResolved: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseMarkChangesResolvedMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseMarkChangesResolvedMutationReturn<T>;
}

type UseRequestAgentToApplyChangesMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.RequestAgentToApplyChangesResponseType>,
    References.RequestAgentToApplyChangesRequestType,
    T extends true
      ? Record<
          'requestAgentToApplyChanges',
          References.RequestAgentToApplyChangesResponseType
        >
      : References.RequestAgentToApplyChangesResponseType
  >;

export function useRequestAgentToApplyChangesMutation<
  T extends boolean = false,
>(
  options?: MutationHookOptions<
    Record<'result', References.RequestAgentToApplyChangesResponseType>,
    References.RequestAgentToApplyChangesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseRequestAgentToApplyChangesMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.REQUEST_AGENT_TO_APPLY_CHANGES_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            requestAgentToApplyChanges: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseRequestAgentToApplyChangesMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseRequestAgentToApplyChangesMutationReturn<T>;
}

type UseRequestAgentToReviewMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.RequestAgentToReviewResponseType>,
    References.RequestAgentToReviewRequestType,
    T extends true
      ? Record<
          'requestAgentToReview',
          References.RequestAgentToReviewResponseType
        >
      : References.RequestAgentToReviewResponseType
  >;

export function useRequestAgentToReviewMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.RequestAgentToReviewResponseType>,
    References.RequestAgentToReviewRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseRequestAgentToReviewMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.REQUEST_AGENT_TO_REVIEW_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            requestAgentToReview: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseRequestAgentToReviewMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseRequestAgentToReviewMutationReturn<T>;
}

type UseCancelAgentTurnMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.CancelAgentTurnResponseType>,
    References.CancelAgentTurnRequestType,
    T extends true
      ? Record<'cancelAgentTurn', References.CancelAgentTurnResponseType>
      : References.CancelAgentTurnResponseType
  >;

export function useCancelAgentTurnMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.CancelAgentTurnResponseType>,
    References.CancelAgentTurnRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseCancelAgentTurnMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.CANCEL_AGENT_TURN_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            cancelAgentTurn: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseCancelAgentTurnMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseCancelAgentTurnMutationReturn<T>;
}

type UseCancelApprovalMutationReturn<T extends boolean> = MutationTupleOverride<
  Record<'result', References.CancelApprovalResponseType>,
  References.CancelApprovalRequestType,
  T extends true
    ? Record<'cancelApproval', References.CancelApprovalResponseType>
    : References.CancelApprovalResponseType
>;

export function useCancelApprovalMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.CancelApprovalResponseType>,
    References.CancelApprovalRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseCancelApprovalMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.CANCEL_APPROVAL_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            cancelApproval: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseCancelApprovalMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseCancelApprovalMutationReturn<T>;
}

type UseConcludeApprovalMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.ConcludeApprovalResponseType>,
    References.ConcludeApprovalRequestType,
    T extends true
      ? Record<'concludeApproval', References.ConcludeApprovalResponseType>
      : References.ConcludeApprovalResponseType
  >;

export function useConcludeApprovalMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.ConcludeApprovalResponseType>,
    References.ConcludeApprovalRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseConcludeApprovalMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.CONCLUDE_APPROVAL_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            concludeApproval: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseConcludeApprovalMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseConcludeApprovalMutationReturn<T>;
}

type UseUpdateApprovalMutationReturn<T extends boolean> = MutationTupleOverride<
  Record<'result', References.UpdateApprovalResponseType>,
  References.UpdateApprovalRequestType,
  T extends true
    ? Record<'updateApproval', References.UpdateApprovalResponseType>
    : References.UpdateApprovalResponseType
>;

export function useUpdateApprovalMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.UpdateApprovalResponseType>,
    References.UpdateApprovalRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseUpdateApprovalMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.UPDATE_APPROVAL_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            updateApproval: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseUpdateApprovalMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseUpdateApprovalMutationReturn<T>;
}

type UseSendReminderNotificationMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.SendReminderNotificationResponseType>,
    References.SendReminderNotificationRequestType,
    T extends true
      ? Record<
          'sendReminderNotification',
          References.SendReminderNotificationResponseType
        >
      : References.SendReminderNotificationResponseType
  >;

export function useSendReminderNotificationMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.SendReminderNotificationResponseType>,
    References.SendReminderNotificationRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSendReminderNotificationMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.SEND_REMINDER_NOTIFICATION_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            sendReminderNotification: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseSendReminderNotificationMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseSendReminderNotificationMutationReturn<T>;
}
